import { Component, OnInit, Input } from '@angular/core';
import ITaskItemDTO = ZoningAPI.ITaskItemDTO;

@Component({
    standalone: false,
    selector: 'app-process-task-items-list',
    templateUrl: './process-task-items-list.component.html',
    styleUrls: ['./process-task-items-list.component.scss']
})
export class ProcessTaskItemsListComponent implements OnInit {
    @Input()
    taskItems: ITaskItemDTO[] = [];

    displayedColumns: string[] = ['id', 'gridicsId', 'folioNumber', 'groupId', 'metaData'];

    constructor() {}

    ngOnInit(): void {}
}
